import React, { useEffect, useState } from "react";
import { subscribeToast, clearToast } from "../shared/toast";

// The single global toast. Auto-dismisses after a few seconds; click x to close.
export default function Toast() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => subscribeToast(setMsg), []);
  useEffect(() => {
    if (!msg) return;
    const t = setTimeout(clearToast, 6000);
    return () => clearTimeout(t);
  }, [msg]);
  if (!msg) return null;
  return (
    <div
      role="alert"
      style={{
        position: "fixed", top: 88, left: "50%", transform: "translateX(-50%)", zIndex: 3000,
        display: "flex", alignItems: "center", gap: 14, width: "min(94vw, 560px)", boxSizing: "border-box",
        background: "#20160c", border: "1px solid rgba(255,159,69,0.6)", borderLeft: "5px solid #ff9f45",
        borderRadius: 14, padding: "16px 16px 16px 18px",
        boxShadow: "0 16px 40px rgba(0,0,0,0.55)",
        color: "#fff", fontFamily: "Rajdhani, system-ui, sans-serif", fontWeight: 700, fontSize: 17, letterSpacing: 0.2,
        animation: "ar-toast-in 0.34s cubic-bezier(.2,1.35,.35,1)",
      }}
    >
      <style>{"@keyframes ar-toast-in{0%{opacity:0;transform:translate(-50%,-18px) scale(.96)}60%{opacity:1}100%{opacity:1;transform:translate(-50%,0) scale(1)}}"}</style>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ff9f45" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ flex: "0 0 auto" }}>
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>
      <span style={{ flex: 1, minWidth: 0 }}>{msg}</span>
      <button
        type="button"
        onClick={clearToast}
        title="Dismiss"
        style={{ flex: "0 0 auto", width: 30, height: 30, display: "inline-flex", alignItems: "center", justifyContent: "center", borderRadius: 8, border: "none", background: "rgba(255,255,255,0.08)", color: "#cbd3e6", cursor: "pointer", fontSize: 20, lineHeight: 1 }}
      >
        ×
      </button>
    </div>
  );
}
